export default __webpack_public_path__ + "static/media/product-01 (1).7badc1d8.jpg";